import THEME_MODE from 'constants/themeMode.const';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import withOptions from 'utils/functions/withOptions.util';
import isEnumVal from 'utils/predicates/enum/isEnumVal.util';

const determineCalendarModes = withOptions(({ calendarMode, defaultMode, hasBright, relayMode }) => {
  const cm = fromAnyToTrimmed(calendarMode);

  const isDarkMode = THEME_MODE.dark === cm;
  const isLightMode = THEME_MODE.light === cm;
  const isBrightMode = hasBright && !isLightMode && !isDarkMode;

  if (isDarkMode || isLightMode || isBrightMode) {
    const result = { isBrightMode, isDarkMode, isLightMode };
    if (relayMode) result.calendarMode = calendarMode;
    return result;
  }

  // they're all falsy, data might be missing, try the default
  if (isEnumVal(THEME_MODE, defaultMode)) {
    const result = {
      isBrightMode: THEME_MODE.bright === defaultMode,
      isDarkMode: THEME_MODE.dark === defaultMode,
      isLightMode: THEME_MODE.light === defaultMode,
    };
    if (relayMode) result.calendarMode = calendarMode;
    return result;
  }

  // even the defaultMode is missing or invalid, so we pick light
  const result = { isLightMode: true, isDarkMode: false, isBrightMode: false };
  if (relayMode) result.calendarMode = calendarMode;
  return result;
});

export default determineCalendarModes;
